import React from 'react';

const AuthFooter: React.FC = () => {
  return (
    <div className="2xl:absolute 2xl:bottom-8 2xl:left-0 2xl:right-0 mt-12 text-sm">
      <div className="flex flex-wrap gap-2 items-center justify-center text-center">
        <p className="text-[#A0AEC0] mr-4 whitespace-nowrap">
          © 2025 ryno®. All rights reserved.
        </p>
        <p>Terms & Conditions</p>
        <p>|</p>
        <p>Privacy Policy</p>
      </div>
    </div>
  );
};

export default AuthFooter;
